module.exports = __webpack_public_path__ + "static/media/styledmenu-close_Hover.3e5d3da4.svg";